import OutlinedButton from "features/shared/components/buttons/OutlinedButton.styled";
import PrimaryButton from "features/shared/components/buttons/PrimaryButton.styled";
import { Summary } from "features/shared/styles/typography/Summary.styled";
import styled from "styled-components";

const AutomatedTools = styled.div`
  background-color: ${({ theme }) => theme.colors.baseWhite};
  padding: 24px;
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ theme }) => theme.borderRadiusPageCard};
  border: 1px solid ${({ theme }) => theme.colors.base3};

  ${Summary} {
    font-weight: 600;
    margin-bottom: 24px;
  }

  ${PrimaryButton}, ${OutlinedButton} {
    display: block;
    width: 100%;
  }
`;

export default AutomatedTools;
